import { useApp } from '../app-context';

// Yesterday's answer as a proper card (best-practice §11.4). Generic over anime/character.
export default function YesterdayCard({
  image,
  title,
  line1,
  line2,
}: {
  image: string | null;
  title: string;
  line1: string;
  line2: string;
}) {
  const { t } = useApp();
  return (
    <div className="ycard">
      <span className="ycard-eyebrow">{t('yesterday.label')}</span>
      <div className="ycard-body">
        {image && <img src={image} alt={title} width={56} height={80} loading="lazy" />}
        <div className="ycard-info">
          <b>{title}</b>
          <span>{line1}</span>
          <span className="ycard-genres">{line2}</span>
        </div>
      </div>
    </div>
  );
}
